export const SHANGHAI_TIME_ZONE = 'Asia/Shanghai'

const shanghaiDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: SHANGHAI_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

function dateParts(value) {
  const [year, month, day] = value.split('-').map(Number)
  if (!year || !month || !day) throw new Error(`Invalid calendar date: ${value}`)
  return { year, month, day }
}

function formatCalendarDate(date) {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function getShanghaiDate(now = new Date()) {
  const parts = Object.fromEntries(shanghaiDateFormatter.formatToParts(now).map(part => [part.type, part.value]))
  return `${parts.year}-${parts.month}-${parts.day}`
}

export function addCalendarDays(value, amount) {
  const { year, month, day } = dateParts(value)
  const date = new Date(Date.UTC(year, month - 1, day))
  date.setUTCDate(date.getUTCDate() + amount)
  return formatCalendarDate(date)
}

export function getCalendarDateParts(value) {
  const { year, month, day } = dateParts(value)
  const date = new Date(Date.UTC(year, month - 1, day))
  return { day, weekday: date.getUTCDay() }
}
